import { loaderConstant } from "../constants/loader.constant";

export const loaderAction ={
    showLoader,
    hideLoader
}

function showLoader(){
    return (dispatch) =>{
        dispatch(show_loader(true));
    }

    function show_loader(){
        return { type: loaderConstant.SHOW_LOADER};
    }
}

function hideLoader(){
    return (dispatch) =>{
        dispatch(hide_loader(false));
    }

    function hide_loader(){
        return {type: loaderConstant.HIDE_LOADER};
    }
}